import { LayaGL } from "../../../../layagl/LayaGL";
import { Pool } from "../../../../utils/Pool";
import { Stat } from "../../../../utils/Stat";
import { Laya3DRender } from "../../../RenderObjs/Laya3DRender";
import { Command } from "./Command";
export class DrawRenderCMD extends Command {
    static create(render, material, subMeshIndex, commandBuffer) {
        var cmd;
        cmd = DrawRenderCMD._pool.take();
        cmd.render = render;
        cmd.material = material;
        cmd.subMeshIndex = subMeshIndex;
        cmd._commandBuffer = commandBuffer;
        return cmd;
    }
    get render() {
        return this._render;
    }
    set render(render) {
        this._drawNodeCMDData.node = render._baseRenderNode;
        this._render = render;
    }
    get material() {
        return this._material;
    }
    set material(value) {
        this._material && this._material._removeReference(1);
        if (value) {
            value._addReference(1);
            this._drawNodeCMDData.destShaderData = value.shaderData;
            this._drawNodeCMDData.destSubShader = value.shader.getSubShaderAt(0);
        }
        else {
            this._drawNodeCMDData.destShaderData = null;
            this._drawNodeCMDData.destSubShader = null;
        }
        this._material = value;
    }
    get subMeshIndex() {
        return this._subMeshIndex;
    }
    set subMeshIndex(value) {
        this._subMeshIndex = value;
        this._drawNodeCMDData.subMeshIndex = value;
    }
    constructor() {
        super();
        this._drawNodeCMDData = Laya3DRender.Render3DPassFactory.createDrawNodeCMDData();
    }
    getRenderCMD() {
        return this._drawNodeCMDData;
    }
    run() {
        if (this.render) {
            this.render._baseRenderNode.ismoved.setValue(Stat.loopCount, LayaGL.renderEngine._framePassCount);
            this.render.renderUpdate(this._context);
            this._prematerial = this.render.sharedMaterials[this.subMeshIndex];
        }
    }
    recover() {
        DrawRenderCMD._pool.recover(this);
        super.recover();
        this.material = null;
        this.render.sharedMaterials[this.subMeshIndex] = this._prematerial;
        this._render = null;
        this.subMeshIndex = 0;
    }
    destroy() {
        super.destroy();
        this.material = null;
    }
}
DrawRenderCMD._pool = Pool.createPool(DrawRenderCMD);
